import { Component } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

@Component({
	selector: "sdp-wizard-page",
	templateUrl: "./wizard-page.component.html"
})

export class WizardPageComponent {

	public previous = "";
	public next = "";
	public page = "";

	constructor(
		route: ActivatedRoute,
		router: Router
	) {
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.setvalues(route);
			}
		});
	}

	private setvalues(route: ActivatedRoute) {
		const page = route.snapshot.children[0].routeConfig!.path;
		this.page = page || "";
		this.previous = route.snapshot.children[0].data["previous"];
		this.next = route.snapshot.children[0].data["next"];
	}

}
